<template>
<otif-select
    name="operator"
    label="Operator"
    :value="value"
    @input="$emit('input', $event)"
    :values="options"/>

</template>

<script>

export default {

    props: ['value', '$v'],

    data() {
        return {
            options: [
                'equals',
                'equalsIgnoreCase',
                'contains',
                'containsIgnoreCase',
                'startsWith',
                'endsWith',
                'matches',
                '!equals',
                '!equalsIgnoreCase',
                '!contains',
                '!containsIgnoreCase',
                '!startsWith',
                '!endsWith',
                '!matches',
                'greaterThan',
                'lesserThan',
                'greaterOrEqual',
                'lesserOrEqual'
            ]
        }
    }

}

</script>